import React, { useState, useEffect } from "react";

import SavedCardForm from "../billing/forms/settings-card/saved-card-form";
import SaveCardCheckbox from "./SaveCardCheckbox";
import WrappedStripeSplitForm from "./WrappedStripeSplitForm";

import {
    updateStripeFormData,
    setUpdatingCard,
    toggleSaveCard,
} from "./actionCreators";

const PaymentInfoSection = ({
    state,
    dispatch,
    stripePublishableKey,
    clearErrorsWithReduxInStripeState,
}) => {
    const [clearForm, setClearForm] = useState(0);

    useEffect(() => {
        /* when the user clicks "add more icons" after purchasing
        a balance, the `balancePurchased` state will go from `true` to `false`.  
        this state change is used as an indicator of when the page resets. 
        resetting the page includes presenting the user with an empty form, 
        but because we dont' have control over clearing Stripe Element inputs, 
        updating the value of `clearForm` will prompt rendering a new instance of
        `WrappedStripeSplitForm`, which has empty fields.*/
        if (!state.balancePurchased) {
            setClearForm(clearForm + 1);
        }
    }, [state.balancePurchased]);

    const form = stripePublishableKey && (
        <WrappedStripeSplitForm
            key={clearForm}
            stripePublishableKey={stripePublishableKey}
            turnOffAutofocus
            disabled={state.processingRequest}
            handleComplete={(stripeObjectInstance, stripeTokenData) => {
                dispatch(
                    updateStripeFormData({
                        stripeObjectInstance,
                        stripeTokenData,
                    })
                );
            }}
            clearState={() =>
                dispatch(
                    updateStripeFormData({
                        stripeObjectInstance: null,
                        stripeTokenData: null,
                    })
                )
            }
        />
    );

    const useSavedCardButton = (
        <button
            onClick={(e) => {
                e.preventDefault();
                clearErrorsWithReduxInStripeState();
                dispatch(setUpdatingCard({ updatingCard: false }));
            }}
        >
            Use saved card
        </button>
    );

    const updatePaymentInfoButton = (
        <button
            onClick={(e) => {
                e.preventDefault();
                dispatch(setUpdatingCard({ updatingCard: true }));
            }}
        >
            Update payment information
        </button>
    );

    const enteringCardInfo = state.updatingCard || !state.savedCreditCardInfo;
    const notUsingSavedCard = !state.savedCreditCardInfo || state.updatingCard;

    const changeFormButton = state.updatingCard
        ? useSavedCardButton
        : updatePaymentInfoButton;

    return (
        <fieldset>
            <header>
                <h3>Payment Information</h3>
                {state.savedCreditCardInfo && changeFormButton}
            </header>
            {enteringCardInfo ? (
                form
            ) : (
                <SavedCardForm card={state.savedCreditCardInfo} />
            )}
            <ol>
                <li>
                    {notUsingSavedCard && (
                        <SaveCardCheckbox
                            disabled={state.processingRequest}
                            checked={state.saveCardInputChecked}
                            onChange={() => dispatch(toggleSaveCard())}
                        />
                    )}
                </li>
            </ol>
        </fieldset>
    );
};

export default PaymentInfoSection;
